import React, { FunctionComponent } from 'react'
import classnames from 'classnames'

interface Meta {
  error: string
  submitFailed: boolean
}

export interface Props {
  label: string
  input: any // TODO-TS
  meta: Meta
}

const CheckboxField: FunctionComponent<Props> = ({
  label,
  input,
  meta,
  ...rest
}) => {
  const { error, submitFailed } = meta

  return (
    <div className="form__checkbox-wrapper">
      <input
        type="checkbox"
        id={input.name}
        {...input}
        {...rest}
        className={classnames('form__checkbox', {
          'form__control--error': submitFailed && error,
        })}
      />
      <label htmlFor={input.name}>{label}</label>
      {submitFailed && error && (
        <p className="form__help-text text-error">{error}</p>
      )}
    </div>
  )
}

export default CheckboxField
